import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IProjectListStyles {
  root?: IStyle;
  listView?: IStyle;
  listViewWrap?: IStyle;
  cardView?: IStyle;
}

export interface IProjectListClassNames {
  root: string;
  listView: string;
  listViewWrap: string;
  cardView: string;
}

export const projectListStylesDefault = (theme: IH2OTheme): Partial<IProjectListStyles> => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    marginTop: 16,
  },
  listView: {
    flex: 1,
    padding: 24,
    paddingRight: 18,
    backgroundColor: theme.palette?.white,
  },
  listViewWrap: {
    overflow: 'auto',
    height: '100%',
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
});
